import { render, staticRenderFns } from "./SubWallet.vue?vue&type=template&id=584eb074&scoped=true&"
import script from "./SubWallet.vue?vue&type=script&lang=js&"
export * from "./SubWallet.vue?vue&type=script&lang=js&"
import style0 from "./SubWallet.vue?vue&type=style&index=0&id=584eb074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584eb074",
  null
  
)

export default component.exports